import React, { useEffect, useState } from 'react'

import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	FormGroup,
	Input,
	Row,
	Col,
	Label,
	FormFeedback,
} from "reactstrap";
import axios from "axios";
import useForm from "../../formValidator/userForm";
import "./styles.css";

import Loader from '../../components/Loader'

import { STATES, DISTRICTS, BLOCKS } from '../../configs/urls'
import { STATUS_LIST } from '../../configs/constant'
import { getApi, postApi, putApi } from '../../services/api'
import { useHistory } from 'react-router-dom'

const BlockOperations = (props) => {

	const [isRequesting, setIsRequestig] = useState(false)
	const [actionTitle, setActionTitle] = useState('Add Block')
	const [states, setStates] = useState([])
	const [districts, setDistricts] = useState([])
	const history = useHistory()

	useEffect(() => {
		getAllData()
		if (props.match && props.match.params && !props.match.params.block_id) {
			params.status = 1
		}
	}, [])

	const getAllData = () => {
		setIsRequestig(true);

		const states = getApi(STATES);
		const districts = getApi(DISTRICTS);
		let block;

		if (props.match && props.match.params && props.match.params.block_id) {
			block = getApi(BLOCKS + "/" + props.match.params.block_id);
			setActionTitle('Update Block')
		}

		axios
			.all([states, districts, block])
			.then((res) => {

				if (res[0] && res[0].data) {
					setStates(res[0].data)
				}

				if (res[1] && res[1].data) {
					setDistricts(res[1].data)
				}

				if (res[2] && res[2].data) {
					const {
						name,
						status,
						state_id,
						district_id
					} = res[2].data;
					params.name = name;
					params.status = status;
					params.state_id = state_id;
					params.district_id = district_id;
				}
			})
			.catch(() => {

			}).finally(() => {
				setIsRequestig(false)
			})
	};

	const validate = (values) => {
		let errors = {};

		if (!values.name) {
			errors.name = "Block Name is required";
		}

		if (!values.state_id || values.state_id < 0) {
			errors.state_id = "Please select state";
		}

		if (!values.district_id || values.district_id < 0) {
			errors.district_id = "Please select District";
		}

		if (!values.status || values.status < 0) {
			errors.status = "Please select Block Status";
		}

		return errors;
	};

	const saveUpdateDistrict = () => {

		setIsRequestig(true);

		if (props.match && props.match.params && props.match.params.block_id) {
			putApi(`${BLOCKS}/${props.match.params.block_id}`, params).then((res) => {
				history.goBack()
			}, () => {

			}).finally(() => {
				setIsRequestig(false);
			});
		} else {
			postApi(BLOCKS, params)
				.then(
					(res) => {
						history.goBack()
					},
					(err) => { }
				)
				.finally(() => {
					setIsRequestig(false);
				});
		}
	}

	const { params, errors, handleChange, handleSubmit } = useForm(
		saveUpdateDistrict,
		validate
	);

	return (
		<div className="content">
			<Loader isLoading={isRequesting} />
			<form onSubmit={handleSubmit}>
				<Card className="card-user">
					<CardHeader>
						<CardTitle tag="h5">{actionTitle}</CardTitle>
					</CardHeader>
					<hr />
					<CardBody>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<Label for="stateName">State Name</Label>
									<Input
										type="select"
										name="state_id"
										id="stateName"
										value={params.state_id}
										onChange={handleChange}
										invalid={errors.state_id && errors.state_id.length > 0 ? true : false}
									>
										<option value={-1}>Select State</option>
										{
											states.map(state => (
												<option key={state.id} value={state.id}>{state.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.state_id}</FormFeedback>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<Label for="districtName">District Name</Label>
									<Input
										type="select"
										name="district_id"
										id="districtName"
										value={params.district_id}
										onChange={handleChange}
										invalid={errors.district_id && errors.district_id.length > 0 ? true : false}
									>
										<option value={-1}>Select State</option>
										{
											districts.map(district => (
												<option key={district.id} value={district.id}>{district.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.district_id}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<label>Block Name</label>
									<Input
										type="text"
										name="name"
										placeholder="Block Name"
										value={params.name || ""}
										onChange={handleChange}
										invalid={errors.name && errors.name.length > 0 ? true : false}
									/>
									<FormFeedback>{errors.name}</FormFeedback>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<Label for="status">Status</Label>
									<Input
										type="select"
										name="status"
										id="status"
										value={params.status}
										onChange={handleChange}
										invalid={errors.status && errors.status.length > 0 ? true : false}
									>
										{
											STATUS_LIST.map(status => (
												<option key={status.id} value={status.id}>{status.title}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.status}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<div className="update ml-auto mr-auto">
								<Button
									className="btn-round"
									color="primary"
									type="submit"
								>
									{actionTitle}
								</Button>
							</div>
						</Row>
					</CardBody>
				</Card>
			</form>
		</div>
	)
}

export default BlockOperations